import React, { useState } from 'react';
import '../styles/Projects.scss';
import projectsData from "../components/projects/data/projectsData.json";

const Projects = () => {
    const [searchTerm, setSearchTerm] = useState('');

    // Helper function to show half of the description
    const getHalfDescription = (description) => {
        const halfLength = Math.floor(description.length / 2);
        return description.substring(0, halfLength) + '...';
    };

    const filteredProjects = projectsData.projects.filter((project) =>
        project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.date.includes(searchTerm)
    );

    return (
        <main className="projects-page">
            <h2>Our Projects</h2>
            <input
                type="text"
                placeholder="Search by author, date, title, or description"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
            />
            <section className="project-cards-container">
                {filteredProjects.map((project) => (
                    <article key={project.id} className="project-card" onClick={() => window.location.href = `/project/${project.id}`}>
                        <img src={project.imageUrl} alt={project.title} />
                        <h3>{project.title}</h3>
                        <p>{getHalfDescription(project.description)}</p>
                    </article>
                ))}
            </section>
        </main>
    );
};

export default Projects;
